import MainWrapper from "./pages";

function App() {
  return (
    <div className="App">
      <MainWrapper />
    </div>
  );
}

export default App;
